import { configureScope, captureException } from '@sentry/browser'

interface IStudioError {
  path: string
  message: string
  context: any
  nativeError: Error
}

export class StudioError extends Error {
  path: string
  message: string
  context: any
  nativeError: Error

  constructor(error: IStudioError) {
    super(error.message)

    this.path = error.path
    this.message = error.message
    this.context = error.context || null
    this.nativeError = error.nativeError
  }
}

const createError = (
  path: string,
  message: string,
  context?: any,
  nativeError?: Error
): StudioError => {
  const error = new StudioError({
    path,
    message,
    context: context || null,
    nativeError: nativeError || new Error(),
  })

  console.error(`[${error.path}] ${error.message}`, error.context, {
    nativeError: { message: error.nativeError.message },
  })

  // Send this error to Sentry
  configureScope(scope => {
    scope.setExtra('path', path)
    scope.setExtra('message', message)
    scope.setExtra('context', JSON.stringify(context))
    scope.setExtra('nativeError', nativeError)
  })
  captureException(error)

  return error
}

export default createError
